import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import loader from './components/loader'
import flash from './components/flash'
import AppBar from './components/AppBar'
import VuePageTransition from 'vue-page-transition'
import './registerServiceWorker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
library.add(faLink);
library.add(fab);


window.addEventListener('offline', () => {
    store.state.flashMsg = 'Sei offline.'
});
window.addEventListener('online', () => {
    store.state.flashMsg = 'Sei di nuovo online.'
});

Vue.config.productionTip = false;
Vue.component('loader', loader);
Vue.component('flash', flash);
Vue.component('app-bar', AppBar);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VuePageTransition);
Vue.use(Flicking);

const app = new Vue({
    router,
    store,
    vuetify,
    render: function (h) {
        return h(App)
    }
}).$mount('#app');